import OffsetPagingConnection from './pagination/OffsetPagingConnection';
import Reference from './Reference';

export default class ReferenceOffsetConnection extends OffsetPagingConnection {
  constructor(data = {}) {
    super(Reference, data);
  }
}
